import algoliasearch from 'algoliasearch/lite';
import { AisInstantSearch, AisSearchBox, AisIndex, AisHits, AisRefinementList } from "vue-instantsearch/vue3/es";
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { onClickOutside } from "@vueuse/core";
export default {
  components: {
    AisInstantSearch,
    AisSearchBox,
    AisHits,
    AisIndex,
    AisRefinementList
  },
  setup() {
    const searchClient = algoliasearch('GRBEDVPY4Z', '02433ce1ebc554a07057b7d882e2810a');
    const isDropdownVisible = ref(false);
    const searchRef = ref(null);
    const toggleDropdown = event => {
      isDropdownVisible.value = !!event.target.value;
    };
    const dropdownVisible = () => {
      setTimeout(() => {
        isDropdownVisible.value = false;
      }, 1000);
    };
    const openDropdown = () => {
      isDropdownVisible.value = true;
    };
    const closeDropdown = () => {
      isDropdownVisible.value = false;
    };
    onMounted(() => {
      const stop = onClickOutside(searchRef, closeDropdown);
      onBeforeUnmount(() => {
        stop();
      });
    });
    return {
      searchClient,
      isDropdownVisible,
      searchRef,
      toggleDropdown,
      openDropdown,
      dropdownVisible
    };
  }
};